// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const toxicroak: PokeData = {
  "id": 454,
  "name": "toxicroak",
  "height": 13,
  "weight": 444,
  "base_experience": 172,
  "types": [
    PokeType.POISON,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "poison-sting",
    "low-kick",
    "toxic",
    "feint-attack",
    "sludge-bomb",
    "mud-slap",
    "swagger",
    "pursuit",
    "rock-smash",
    "flatter",
    "taunt",
    "revenge",
    "astonish",
    "close-combat",
    "sucker-punch",
    "poison-jab",
    "earth-power",
    "nasty-plot",
    "mud-bomb",
    "venoshock",
    "belch"
  ],
  "moves": [
    "sludge-bomb",
    "mud-slap",
    "pursuit",
    "rock-smash",
    "flatter",
    "close-combat",
    "poison-jab",
    "earth-power",
    "mud-bomb",
    "mortal-gas",
    "bulk-up",
    "vacuum-wave",
    "stun-spore"
  ],
  "evolution_chain": {
    "id": 235,
    "item": null,
    "species": [
      {
        "name": "croagunk",
        "order": 473,
        "types": [
          PokeType.POISON,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "toxicroak",
        "order": 474,
        "types": [
          PokeType.POISON,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 453,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 112,
    "speed": 128,
    "ability_power": 160
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
